import "../Branches.css";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  commonGetData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { getAssignedStaffsQuestionsListPath } from "../../../services/config";
import { AgGridReact } from "ag-grid-react";
import { ToastContainer, toast } from "react-toastify";

import { Link, useSearchParams } from "react-router-dom";
// icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PiEye } from "react-icons/pi";
import { RiDownload2Fill } from "react-icons/ri";
import Slide from "@mui/material/Slide";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const QuestionList = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const [searchParams] = useSearchParams();
  const outletId = searchParams.get("outletId");
  const staffId = searchParams.get("staffId");
  const staffName = searchParams.get("staffName");

  const dispatch = useDispatch();
  const auditState = useSelector((state) => state.common);
  const [auditQuestions, setAuditQuestions] = useState([]);
  // Variable -----------------------------------

  const getAnswer = useCallback(() => {
    dispatch(
      commonGetData(
        getAssignedStaffsQuestionsListPath(
          user.user_id,
          outletId,
          staffId
        )
      )
    );
  }, []);

  useEffect(() => {
    getAnswer();
  }, []);

  useEffect(() => {
    if (auditState.commonGetSuccess || auditState.commonGetError) {
      console.log(auditState.commonGetData);
      if (auditState.commonGetSuccess && auditState.commonGetData) {
        setAuditQuestions(auditState.commonGetData);
        // setAnswer(auditState.commonGetData[0].answers);
      } else {
        setAuditQuestions([]);
      }
    }
  }, [dispatch, auditState]);

  const columns = [
    { headerName: "Title", field: "auditModelName", flex: 1 },
    {
      headerName: "Action",
      field: "id",
      width: 150,
      cellRenderer: (rowData) => {
        return (
          <div className="Branches-table-button">
            <Link
              onClick={() =>
                localStorage.setItem(
                  "auditAnswer",
                  JSON.stringify(rowData.data)
                )
              }
              to={`/audit-question-answer?outletId=${outletId}&staffId=${staffId}&staffName=${staffName}&auditModelId=${rowData.data.auditModelId}&frequency=${rowData.data.frequency}`}
            >
              <PiEye
                style={{
                  cursor: "pointer",
                  fontSize: 20,
                  color: "#04caf1",
                  marginRight: "10px",
                }}
              />
            </Link>
          </div>
        );
      },
    },
  ];

  return (
    <div className="branch-section">
      <div
        className="SettingBody-head"
        style={{
          borderBottom: "1px solid lightgray",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "55px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "10px",
          }}
        >
          <Link
            to={`/outlet-assigned-employee?outletId=${outletId}&userId=${user.user_id}`}
          >
            <ArrowBackIcon sx={{ scale: 1 }} />
          </Link>
          <p>Question List</p>
        </div>
      </div>
      <div className="branch-container">
        <div className="ag-theme-quartz" style={{ height: 500, width: "100%" }}>
          <AgGridReact
            rowData={Array.isArray(auditQuestions) ? auditQuestions : []}
            columnDefs={columns}
            pagination
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
          />
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default QuestionList;
